"use client";

import { withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import React from "react";
import * as Flex from "@repo/ui/flex";
import { ComponentProps } from "../../types/component-props";
import { isMobile } from "../utils";
import MediaCta, { MediaCtaFieldsProps } from "./media-cta";
import classes from "./media-cta.module.css";

export type MediaCtaGridProps = ComponentProps & {
  fields: {
    data: {
      datasource: {
        displayName: string;
        mediaCtas: { results: MediaCtaFieldsProps[] };
      };
    };
  };
};

const MediaCtaGrid = ({
  rendering,
  params,
  fields: {
    data: {
      datasource: {
        mediaCtas: { results: mediaCtasResult },
      },
    },
  },
}: MediaCtaGridProps) => {
  const mobileView = isMobile();

  if (!mediaCtasResult || mediaCtasResult.length === 0) {
    return null;
  }

  return (
    <>
      <Flex.Container
        column={mobileView as boolean}
        className={
          classes[
            mobileView ? "mobileHeroMediaContainer" : "mediaCtaGridContainer"
          ]
        }
      >
        {mediaCtasResult.map((mediaCta, index) => (
          <MediaCta
            key={index}
            rendering={rendering}
            params={params}
            fields={mediaCta}
          />
        ))}
      </Flex.Container>
    </>
  );
};

export default withDatasourceCheck()<MediaCtaGridProps>(MediaCtaGrid);
